import { type PropsWithChildren, type ReactNode } from 'react';
import PageTitle from 'components/common/PageTitle';
import s from './LegalPage.module.scss';

type TLinkProps = PropsWithChildren<{ href: string }>;
type TTitledProps = PropsWithChildren<{ title?: ReactNode }>;
type TListProps = PropsWithChildren<{ ordered?: boolean; start?: number }>;
type TItemProps = PropsWithChildren<{ emphasized?: boolean }>;

export const ExternalLink = ({ href, children }: TLinkProps) => (
  <a href={href} target="_blank" rel="noopener noreferrer">
    {children}
  </a>
);

export const LegalSection = ({ title, children }: TTitledProps) => (
  <section className={s.section}>
    {title ? <h2>{title}</h2> : null}
    {children}
  </section>
);

export const LegalList = ({ children, ordered = false, start }: TListProps) => {
  const List = ordered ? 'ol' : 'ul';

  return (
    <List className={s.list} start={ordered ? start : undefined}>
      {children}
    </List>
  );
};

export const LegalListItem = ({ children, emphasized }: TItemProps) => (
  <li className={emphasized ? s.emphasized : undefined}>{children}</li>
);

export default function LegalPage({ title, children }: TTitledProps) {
  return (
    <article className={s.page}>
      <PageTitle auth>{title}</PageTitle>
      {children}
    </article>
  );
}
